import { HTTPv2, Service } from '@/services/config'
import {
  IInsertPreparationServiceRequest,
  IUpdateIndividualPreparationServiceRequest,
  IUpdatePreparationServiceRequest,
} from '@/types/preparation.types'
import { removePropertyEmpty } from '@/utils'

class PreparationServiceV2 extends Service {
  path = 'preparacao'

  constructor() {
    super(HTTPv2)
  }

  async getInspections(params: any) {
    const httpResponse = await this.httpClient.get(`/${this.path}/obtervistorias`, {
      params: removePropertyEmpty(params),
    })
    return httpResponse
  }

  async putInspection(params: any) {
    const httpResponse = await this.httpClient.put(`/${this.path}`, params)
    return httpResponse
  }

  async getServices(preparacaoId: string) {
    const httpResponse = await this.httpClient.get(`/${this.path}/servicos`, {
      params: preparacaoId,
    })
    return httpResponse
  }

  async postService(params: IInsertPreparationServiceRequest) {
    const httpResponse = await this.httpClient.post(`/${this.path}/inserirservico`, params)
    return httpResponse
  }

  async putService(params: IUpdatePreparationServiceRequest) {
    const httpResponse = await this.httpClient.put(`/${this.path}/atualizarservicos`, params)
    return httpResponse
  }

  async putIndividualService(params: IUpdateIndividualPreparationServiceRequest) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/atualizarservicosindividual`,
      params,
    )
    return httpResponse
  }

  async getBreakdown(preparacaoId: string) {
    const httpResponse = await this.httpClient.get(`/${this.path}/obter-avarias/${preparacaoId}`)
    return httpResponse
  }
}

export const preparationServiceV2 = new PreparationServiceV2()
